module.exports = "<div class=\"container\">\r\n    <app-trip-advisor></app-trip-advisor>\r\n    <app-logo></app-logo>\r\n    <app-languages></app-languages>\r\n</div>\r\n\r\n<div class=\"container separator\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = 769
// module chunks = 1